import { Injectable, signal, computed } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoaderService {

  private readonly requestCount = signal(0);
  private readonly _isLoading = signal(false);
  readonly readIsLoading = computed(() => this._isLoading());

  private hideTimer: any;
  private readonly HIDE_DELAY = 150; // ms

  showLoader() {
    this.requestCount.update(count => count + 1);
    this._isLoading.set(true);

    // If there was a pending hide timer from a previous request, cancel it
    if (this.hideTimer) {
      clearTimeout(this.hideTimer);
      this.hideTimer = null;
    }
  }

  hideLoader() {
    this.requestCount.update(count => Math.max(count - 1, 0));

    // Only start hide timer if this was the last pending request
    if (this.requestCount() === 0) {
      // Clear existing timer
      if (this.hideTimer) clearTimeout(this.hideTimer);

      this.hideTimer = setTimeout(() => {
        this._isLoading.set(false);
        this.hideTimer = null;
      }, this.HIDE_DELAY);
    }
  }

}
